import { createClient } from '@supabase/supabase-js'

// Read replica client for analytics operations
// This connects to the read replica to avoid timeout issues on the main database
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "http://127.0.0.1:55432"
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzY2ODk0MzkyLCJleHAiOjI3MTI5NzQzOTJ9.eY6l0ZfnsoWUGlMlnmeZnHG7bKpdggO7A8w__InWK1o"

// For localhost development, we'll use the same URL/key since there's no separate replica
// In production, you should update these with your read replica connection details from Supabase dashboard
const replicaUrl = import.meta.env.VITE_SUPABASE_REPLICA_URL || supabaseUrl
const replicaKey = import.meta.env.VITE_SUPABASE_REPLICA_KEY || supabaseKey

export const supabaseReplica = createClient(replicaUrl, replicaKey, {
  db: {
    schema: 'public',
  },
  auth: {
    persistSession: false,
  },
})

// Helper to determine if we should use replica for a given operation
export const shouldUseReplica = (operation: 'read' | 'write' | 'analytics') => {
  // Disable replica usage if replica environment variables are not set
  if (!import.meta.env.VITE_SUPABASE_REPLICA_URL || !import.meta.env.VITE_SUPABASE_REPLICA_KEY) {
    return false
  }

  switch (operation) {
    case 'analytics':
    case 'read':
      return true
    case 'write':
      return false
    default:
      return false
  }
}